// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7de7f98e","455":"1e396006","977":"3ee79180"}[chunkId] + ".chunk.js";
};